import { render, staticRenderFns } from "./status-pill.vue?vue&type=template&id=f3fdf052&scoped=true&"
import script from "./status-pill.vue?vue&type=script&lang=js&"
export * from "./status-pill.vue?vue&type=script&lang=js&"
import style0 from "./status-pill.vue?vue&type=style&index=0&id=f3fdf052&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3fdf052",
  null
  
)

export default component.exports